export const iconFontAwesomeHumanitarianSquareVirus = (
	<i className="fa-solid fa-square-virus"></i>
);
